import React, {Component} from 'react'
import Helmet from 'react-helmet'
import {FormattedMessage, injectIntl} from 'react-intl'

class FourOhFour extends Component {
  render () {
    return (
      <article>
        <Helmet>
          <meta name="robots" content="noindex" />
          <title>{this.props.intl.formatMessage({id:'cantFindThat'})}</title>
        </Helmet>

        <hgroup>
          <h1>Rebecca & Eric</h1>
          <h2>
            <FormattedMessage id="cantFindThat" />
          </h2>
        </hgroup>

        <p>
          <FormattedMessage id="sorry404" />
        </p>
      </article>
    )
  }
}

export default injectIntl(FourOhFour)



// WEBPACK FOOTER //
// ./src/FourOhFour.js